<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('menu.localities')">
          <form ref="form">
            <input id="locality-id" type="hidden" v-model="locality.id" />
            
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input v-model="locality.code" placeholder="Código"/>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="locality.name" placeholder="Nome"/>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="locality.address" placeholder="Endereço"/>
              </div>
            </div>

            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input v-model="locality.district" placeholder="Bairro"/>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="locality.city" placeholder="Cidade"/>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input v-model="locality.state" placeholder="Estado"/>
              </div>
            </div>

            <div class="row">
              <div class="flex xs12 sm3">
                <va-button
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="save(locality)">
                  {{ $t('menu.save') }}
                </va-button>

                <BackButton />
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from '../shared/BackButton'
import { http } from "@/services/config";
import { showError } from '@/global'
export default {
  components: { BackButton },
  data(){
    return {
      locality: {
       code: '',
       name: '',
       address: '',
       district: '',
       city: '',
       state: ''
      }
    }
  },

  mounted(){
    this.getLocality()
  },

  methods: {
    getLocality(){
      if (this.$route.params.id != undefined){
        http.get(`/localities/${this.$route.params.id}`).then(response => {
          this.locality = response.data["locality"]
        }).catch(e => showError(e))
      }
    },
    
    save() {
      if (this.locality.id) {
        http.put(`/localities/${this.locality.id}`, this.locality).then(response => {
          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
          this.$router.push({ name: "localities" })
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      } else {
        http.post(`/localities`, this.locality).then(response => {
          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
          this.$router.push({ name: "localities" })
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      }
    },
  }

}
</script>

<style>

</style>